import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import GuideItem from '@PROJECT_ROOT/assets/responsive-frontend/pages/GuideItem/GuideItemContent';
import GlobalPageComponents from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/globalPageComponents';
import initAfterContentComponent from '@PROJECT_ROOT/assets/responsive-frontend/js/services/AfterContentComponent';
import initMobileFixedButtonsWhereItsOnlySearch from '@PROJECT_ROOT/assets/responsive-frontend/js/services/initMobileFixedButtonsWhereItsOnlySearch';
import { PageContextProvider } from '@PROJECT_ROOT/assets/responsive-frontend/js/contexts/PageContext';

const guideItem = document.getElementById(pageConfig.guideItemPage.id);
if (guideItem) {
    const ssrData = window.SSR_DATA || null;
    const ssrParameters = window.SSR_PARAMETERS || null;

    hydrateRoot(
        guideItem,
        <>
            <GlobalPageComponents />
            <PageContextProvider userJWT={ssrParameters?.userJWT}>
                <GuideItem publicResourcesSSR={ssrData} />
            </PageContextProvider>
        </>,
    );
}
initAfterContentComponent();
initMobileFixedButtonsWhereItsOnlySearch();
